// ==================== Payroll Enums ====================

export enum PayCycle {
  Monthly = 0,
  Weekly = 1,
}

export const PayCycleLabels: Record<PayCycle, string> = {
  [PayCycle.Monthly]: 'Monthly',
  [PayCycle.Weekly]: 'Weekly',
};

export enum PayslipLogoPosition {
  Left = 0,
  Right = 1,
}

export const PayslipLogoPositionLabels: Record<PayslipLogoPosition, string> = {
  [PayslipLogoPosition.Left]: 'Left',
  [PayslipLogoPosition.Right]: 'Right',
};

export enum PayslipStampPosition {
  Left = 0,
  Right = 1,
}

export const PayslipStampPositionLabels: Record<PayslipStampPosition, string> = {
  [PayslipStampPosition.Left]: 'Left',
  [PayslipStampPosition.Right]: 'Right',
};

export enum PayrollElementValueType {
  Fixed = 1,
  Computed = 2,
}

export const PayrollElementValueTypeLabels: Record<PayrollElementValueType, string> = {
  [PayrollElementValueType.Fixed]: 'Fixed',
  [PayrollElementValueType.Computed]: 'Computed',
};

export enum BankTemplateColumnSourceType {
  System = 1,
  Custom = 2,
}

export const BankTemplateColumnSourceTypeLabels: Record<BankTemplateColumnSourceType, string> = {
  [BankTemplateColumnSourceType.System]: 'System',
  [BankTemplateColumnSourceType.Custom]: 'Custom',
};

export enum SalaryComponentType {
  Earning = 0,
  Deduction = 1,
  Allowance = 2,
  Contribution = 3,
  ReimbursableComponent = 4,
  BaseComponent = 5,
  VariablePay = 6,
  Overtime = 7,
  TaxComponent = 8,
  LeaveComponent = 9,
}

export const SalaryComponentTypeLabels: Record<SalaryComponentType, string> = {
  [SalaryComponentType.Earning]: 'Earning',
  [SalaryComponentType.Deduction]: 'Deduction',
  [SalaryComponentType.Allowance]: 'Allowance',
  [SalaryComponentType.Contribution]: 'Contribution',
  [SalaryComponentType.ReimbursableComponent]: 'Reimbursable Component',
  [SalaryComponentType.BaseComponent]: 'Base Component',
  [SalaryComponentType.VariablePay]: 'Variable Pay',
  [SalaryComponentType.Overtime]: 'Overtime',
  [SalaryComponentType.TaxComponent]: 'Tax Component',
  [SalaryComponentType.LeaveComponent]: 'Leave Component',
};

export const SalaryComponentTypeColors: Record<SalaryComponentType, 'success' | 'error' | 'info' | 'warning' | 'secondary' | 'primary'> = {
  [SalaryComponentType.Earning]: 'success',
  [SalaryComponentType.Deduction]: 'error',
  [SalaryComponentType.Allowance]: 'info',
  [SalaryComponentType.Contribution]: 'warning',
  [SalaryComponentType.ReimbursableComponent]: 'secondary',
  [SalaryComponentType.BaseComponent]: 'primary',
  [SalaryComponentType.VariablePay]: 'success',
  [SalaryComponentType.Overtime]: 'info',
  [SalaryComponentType.TaxComponent]: 'error',
  [SalaryComponentType.LeaveComponent]: 'warning',
};

export enum SalaryComponentConsiderAs {
  Earnings = 0,
  Deductions = 1,
  EmployerContributions = 2,
  Reimbursements = 3,
}

export const SalaryComponentConsiderAsLabels: Record<SalaryComponentConsiderAs, string> = {
  [SalaryComponentConsiderAs.Earnings]: 'Earnings',
  [SalaryComponentConsiderAs.Deductions]: 'Deductions',
  [SalaryComponentConsiderAs.EmployerContributions]: 'Employer Contributions',
  [SalaryComponentConsiderAs.Reimbursements]: 'Reimbursements',
};

export enum PayrollRunStatus {
  Draft = 0,
  Processed = 1,
  Locked = 2,
  Review = 3,
  Approved = 4,
  Paid = 5,
}

export const PayrollRunStatusLabels: Record<PayrollRunStatus, string> = {
  [PayrollRunStatus.Draft]: 'Draft',
  [PayrollRunStatus.Processed]: 'Processed',
  [PayrollRunStatus.Locked]: 'Locked',
  [PayrollRunStatus.Review]: 'Review',
  [PayrollRunStatus.Approved]: 'Approved',
  [PayrollRunStatus.Paid]: 'Paid',
};

export const PayrollRunStatusColors: Record<PayrollRunStatus, 'default' | 'warning' | 'info' | 'success'> = {
  [PayrollRunStatus.Draft]: 'default',
  [PayrollRunStatus.Processed]: 'info',
  [PayrollRunStatus.Locked]: 'success',
  [PayrollRunStatus.Review]: 'warning',
  [PayrollRunStatus.Approved]: 'success',
  [PayrollRunStatus.Paid]: 'success',
};

export enum PayrollAdjustmentType {
  Bonus = 0,
  Incentive = 1,
  Overtime = 2,
  Reimbursement = 3,
  LopAdjustment = 4,
  AttendanceCorrection = 5,
  AdvanceDeduction = 6,
}

export const PayrollAdjustmentTypeLabels: Record<PayrollAdjustmentType, string> = {
  [PayrollAdjustmentType.Bonus]: 'Bonus',
  [PayrollAdjustmentType.Incentive]: 'Incentive',
  [PayrollAdjustmentType.Overtime]: 'OT Amount',
  [PayrollAdjustmentType.Reimbursement]: 'Reimbursement',
  [PayrollAdjustmentType.LopAdjustment]: 'LOP Adjustment',
  [PayrollAdjustmentType.AttendanceCorrection]: 'Attendance Correction',
  [PayrollAdjustmentType.AdvanceDeduction]: 'Advance Deduction',
};

export enum PayrollProrationBasis {
  CalendarDays = 0,
  ScheduledWorkingDays = 1,
}

export const PayrollProrationBasisLabels: Record<PayrollProrationBasis, string> = {
  [PayrollProrationBasis.CalendarDays]: 'Calendar Days',
  [PayrollProrationBasis.ScheduledWorkingDays]: 'Working Days',
};

export enum TaxDeclarationStatus {
  Draft = 0,
  Submitted = 1,
  Approved = 2,
}

export const TaxDeclarationStatusLabels: Record<TaxDeclarationStatus, string> = {
  [TaxDeclarationStatus.Draft]: 'Draft',
  [TaxDeclarationStatus.Submitted]: 'Submitted',
  [TaxDeclarationStatus.Approved]: 'Approved',
};

export const TaxDeclarationStatusColors: Record<TaxDeclarationStatus, 'default' | 'warning' | 'success'> = {
  [TaxDeclarationStatus.Draft]: 'default',
  [TaxDeclarationStatus.Submitted]: 'warning',
  [TaxDeclarationStatus.Approved]: 'success',
};

export enum TaxProofStatus {
  Pending = 0,
  Submitted = 1,
  Verified = 2,
  Rejected = 3,
}

export const TaxProofStatusLabels: Record<TaxProofStatus, string> = {
  [TaxProofStatus.Pending]: 'Pending',
  [TaxProofStatus.Submitted]: 'Submitted',
  [TaxProofStatus.Verified]: 'Verified',
  [TaxProofStatus.Rejected]: 'Rejected',
};

export const TaxProofStatusColors: Record<TaxProofStatus, 'default' | 'warning' | 'success' | 'error'> = {
  [TaxProofStatus.Pending]: 'default',
  [TaxProofStatus.Submitted]: 'warning',
  [TaxProofStatus.Verified]: 'success',
  [TaxProofStatus.Rejected]: 'error',
};

// ==================== DTOs ====================

export interface PayrollSettingDto {
  id: string;
  payCycle: PayCycle;
  salaryDay: number;
  pfEnabled: boolean;
  esiEnabled: boolean;
  tdsEnabled: boolean;
  professionalTaxEnabled: boolean;
  configuration: PayrollConfigurationDto;
}

export interface SavePayrollSetting {
  payCycle: PayCycle;
  salaryDay: number;
  pfEnabled: boolean;
  esiEnabled: boolean;
  tdsEnabled: boolean;
  professionalTaxEnabled: boolean;
  configuration?: PayrollConfigurationDto;
}

export interface PayrollConfigurationDto {
  groups: PayrollGroupDto[];
  taxes: PayrollTaxConfigurationDto;
  payslipTemplates: PayslipTemplateDto[];
  bankTemplate: BankTemplateDto | null;
  moduleConfiguration: PayrollModuleConfigurationDto;
}

export interface PayrollGroupDto {
  id: string;
  name: string;
  description?: string | null;
  formula?: string | null;
  displayOrder: number;
  isActive: boolean;
  computedValue: number;
  elements: PayrollGroupElementDto[];
}

export interface PayrollGroupElementDto {
  id: string;
  elementCode: string;
  elementName: string;
  valueType: PayrollElementValueType;
  value?: number | null;
  formula?: string | null;
  displayOrder: number;
  isActive: boolean;
  computedValue: number;
}

export interface PayrollTaxConfigurationDto {
  financial: PayrollFinancialConfigurationDto;
  incomeTaxSlabs: IncomeTaxSlabDto[];
  exemptions: TaxExemptionDto[];
  labourWelfareFunds: LabourWelfareFundDto[];
  stateTaxSlabs: StateTaxSlabDto[];
}

export interface PayrollFinancialConfigurationDto {
  financialYear: string;
  standardDeduction: number;
  cessPercentage: number;
  taxRegime?: string | null;
}

export interface IncomeTaxSlabDto {
  id: string;
  regime: string;
  incomeFrom: number;
  incomeTo?: number | null;
  taxPercentage: number;
  surchargePercentage?: number | null;
}

export interface TaxExemptionDto {
  id: string;
  section: string;
  description?: string | null;
  maximumAmount: number;
}

export interface LabourWelfareFundDto {
  id: string;
  stateCode: string;
  employeeContribution: number;
  employerContribution: number;
  effectiveFrom?: string | null;
}

export interface StateTaxSlabDto {
  id: string;
  stateCode: string;
  amountFrom: number;
  amountTo?: number | null;
  taxAmount: number;
}

export interface PayslipTemplateDto {
  id: string;
  name: string;
  headerTemplate: string;
  bodyTemplate: string;
  footerTemplate: string;
  isDefault: boolean;
}

export interface BankTemplateDto {
  id: string;
  name: string;
  columns: BankTemplateColumnDto[];
}

export interface BankTemplateColumnDto {
  id: string;
  columnName: string;
  sourceKey: string;
  sourceType: BankTemplateColumnSourceType;
  format?: string | null;
  displayOrder: number;
  isRequired: boolean;
}

export interface PayrollModuleConfigurationDto {
  autoGeneratePayslip: boolean;
  enableBankAdviceExport: boolean;
  enableProration: boolean;
  prorationBasis: PayrollProrationBasis;
  lockPayslipAfterPayroll: boolean;
  overtimeHourlyRate: number;
  overtimeMultiplier: number;
  defaultPayslipTemplateId?: string | null;
  defaultBankTemplateId?: string | null;
  companyLogoUrl?: string | null;
  logoPosition?: PayslipLogoPosition;
  companyStampUrl?: string | null;
  stampPosition?: PayslipStampPosition;
}

export interface PayrollGroupCalculationPreviewDto {
  computedValue: number;
  elements: PayrollGroupElementDto[];
}

export interface SalaryComponentDto {
  id: string;
  name: string;
  label: string;
  type: SalaryComponentType;
  considerAs: SalaryComponentConsiderAs;
  isTaxable: boolean;
  isStatutory: boolean;
  isActive: boolean;
}

export interface CreateSalaryComponent {
  name: string;
  label: string;
  type: SalaryComponentType;
  considerAs: SalaryComponentConsiderAs;
  isTaxable: boolean;
  isStatutory: boolean;
}

export interface UpdateSalaryComponent extends CreateSalaryComponent {
  isActive: boolean;
}

export interface SalaryStructureDto {
  id: string;
  employeeId: string;
  employeeName: string;
  ctc: number;
  effectiveFrom: string;
  components: EmployeeSalaryComponentDto[];
}

export interface EmployeeSalaryComponentDto {
  id: string;
  componentId: string;
  componentName: string;
  componentType: SalaryComponentType;
  amount: number;
}

export interface SaveSalaryStructure {
  employeeId: string;
  ctc: number;
  effectiveFrom: string;
  components: { componentId: string; amount: number }[];
}

export interface PayrollGroupAssignmentOptionDto {
  id: string;
  name: string;
}

export interface PayrollGroupAssignmentEmployeeDto {
  employeeId: string;
  employeeName: string;
  employeeCode?: string | null;
  departmentId?: string | null;
  departmentName?: string | null;
  payrollEnabled: boolean;
  isActive: boolean;
  assignedGroupId?: string | null;
  assignedBaseAmount?: number | null;
  assignmentEffectiveFrom?: string | null;
}

export interface PayrollGroupAssignmentOptionsResponseDto {
  groups: PayrollGroupDto[];
  departments: PayrollGroupAssignmentOptionDto[];
  employees: PayrollGroupAssignmentEmployeeDto[];
}

export interface ApplyPayrollGroupEmployeeInput {
  employeeId: string;
  baseAmount?: number | null;
}

export interface ApplyPayrollGroupRequest {
  groupId: string;
  effectiveFrom: string;
  departmentId?: string | null;
  defaultBaseAmount?: number | null;
  employees: ApplyPayrollGroupEmployeeInput[];
}

export interface GeneratedSalaryStructureDto {
  employeeId: string;
  employeeName: string;
  salaryStructureId: string;
  ctc: number;
  grossMonthly: number;
  totalEarnings: number;
  totalDeductions: number;
  netMonthly: number;
}

export interface PayrollGroupGenerationResultDto {
  groupId: string;
  groupName: string;
  effectiveFrom: string;
  processedCount: number;
  items: GeneratedSalaryStructureDto[];
}

export interface PayrollRunDto {
  id: string;
  month: number;
  year: number;
  payCycle: PayCycle;
  periodStart: string;
  periodEnd: string;
  departmentId?: string | null;
  departmentName: string;
  status: PayrollRunStatus;
  processedAt: string | null;
  lockedAt: string | null;
  createdAt: string;
  employeeCount: number;
  employeeIds: string[];
  totalGross: number;
  totalDeductions: number;
  totalNet: number;
}

export interface PayrollRunDetailDto {
  id: string;
  month: number;
  year: number;
  payCycle: PayCycle;
  periodStart: string;
  periodEnd: string;
  status: PayrollRunStatus;
  processedAt: string | null;
  lockedAt: string | null;
  employeeDetails: PayrollEmployeeDetailDto[];
  auditLogs: PayrollAuditLogDto[];
}

export interface PayrollEmployeeDetailDto {
  id: string;
  employeeId: string;
  employeeName: string;
  employeeCode: string;
  grossSalary: number;
  totalEarnings: number;
  totalDeductions: number;
  netSalary: number;
  presentDays: number;
  fullDayDays: number;
  halfDayDays: number;
  leaveDays: number;
  totalCalendarDays: number;
  scheduledWorkingDays: number;
  weeklyOffDays: number;
  paidHolidayDays: number;
  paidLeaveDays: number;
  /** Part of paidLeaveDays taken as Comp Off leave (already included in paidLeaveDays). */
  compOffLeaveDays: number;
  unpaidLeaveDays: number;
  absentDays: number;
  lopDays: number;
  payableDays: number;
  overtimeHours: number;
  overtimeAmount: number;
  lateMarkCount: number;
  lateMarkDeductionDays: number;
  lateMarkDeductionAmount: number;
  loanRecoveryAmount: number;
  adjustments: PayrollAdjustmentDto[];
  componentDetails: PayrollComponentDetailDto[];
}

export interface PayrollComponentDetailDto {
  id: string;
  componentId: string;
  componentName: string;
  type: SalaryComponentType;
  amount: number;
}

export interface PayrollAdjustmentDto {
  id: string;
  employeeId: string;
  adjustmentType: PayrollAdjustmentType;
  componentName: string;
  amount: number;
  remarks?: string | null;
  createdAt: string;
  createdBy: string;
}

export interface PayrollAuditLogDto {
  id: string;
  employeeId?: string | null;
  employeeName?: string | null;
  action: string;
  oldValue?: string | null;
  newValue?: string | null;
  remarks?: string | null;
  createdAt: string;
  createdBy: string;
}

export interface TaxDeclarationDto {
  id: string;
  employeeId: string;
  employeeName: string;
  financialYear: string;
  status: TaxDeclarationStatus;
  totalDeclaredAmount: number;
  items: TaxDeclarationItemDto[];
}

export interface TaxDeclarationItemDto {
  id: string;
  section: string;
  description: string;
  declaredAmount: number;
}

export interface SaveTaxDeclaration {
  employeeId: string;
  financialYear: string;
  items: { section: string; description: string; declaredAmount: number }[];
}

export interface TdsCalculationDto {
  id: string;
  employeeId: string;
  financialYear: string;
  annualIncome: number;
  taxableIncome: number;
  totalTax: number;
  monthlyTds: number;
}

export interface TaxProofDto {
  id: string;
  employeeId: string;
  financialYear: string;
  status: TaxProofStatus;
  documents: TaxProofDocumentDto[];
}

export interface TaxProofDocumentDto {
  id: string;
  section: string;
  filePath: string;
  amount: number;
  verifiedAmount: number | null;
  remarks: string | null;
}

export interface PayslipDto {
  id: string;
  employeeId: string;
  employeeName: string;
  employeeCode?: string | null;
  payrollRunId: string;
  month: number;
  year: number;
  filePath: string;
  generatedAt: string;
}

export interface PayrollDashboardDto {
  totalEmployees: number;
  totalGrossSalary: number;
  totalNetSalary: number;
  totalDeductions: number;
  latestRun: PayrollRunDto | null;
}

export interface PayslipDetailDto {
  payslipId: string;
  month: number;
  year: number;
  generatedAt: string;
  employeeId: string;
  employeeName: string;
  employeeCode: string;
  companyName: string;
  companyAddress: string;
  companyState?: string;
  companyCity?: string;
  companyCountry?: string;
  companyPostalCode?: string;
  companyLogoUrl?: string;
  logoPosition?: 'Left' | 'Right';
  companyStampUrl?: string;
  stampPosition?: 'Left' | 'Right';
  department: string;
  designation: string;
  dateOfJoining: string;
  panNumber: string;
  officialEmail?: string;
  workLocation?: string;
  bankAccountNumber?: string;
  ifscCode?: string;
  workingDays: number;
  scheduledWorkingDays?: number;
  grossSalary: number;
  totalEarnings: number;
  totalDeductions: number;
  netSalary: number;
  presentDays: number;
  halfDayDays?: number;
  leaveDays: number;
  paidLeaveDays?: number;
  unpaidLeaveDays?: number;
  absentDays?: number;
  lopDays?: number;
  payableDays?: number;
  overtimeAmount: number;
  overtimeHours?: number;
  lateMarkCount?: number;
  lateMarkDeductionDays?: number;
  lateMarkDeductionAmount?: number;
  authorizedSignatory?: string;
  payrollGroup?: string;
  template?: PayslipTemplateDto | null;
  components: { componentName: string; type: SalaryComponentType; amount: number }[];
}
